// 是否登录
export const isLogin = (state) => state.isLogin;
// ticket
export const ticket = (state) => state.ticket;
// 登录信息
export const userInfo = (state) => state.userInfo;
// 是否使用优惠券
export const agentId = (state) => state.agentId;
